/**
 * AJAX-URL архива акций.
 *
 * `reverse` на клиенте знает только имена, которые вызвали на SSR
 * (`cachedURLs`). Диалог архива монтируется по клику, поэтому URL
 * нужно резолвить в секции, которая есть в первом кадре.
 */
export default function getLpuPromotionsArchiveUrl(
  reverse: (_opts: { name: string, args?: Array<string | number> }) => string,
  lpuId: number,
): string {
  return reverse({
    name: 'ajax_lpu_promotions_archive',
    args: [lpuId],
  }) || `/ajax/lpu/${lpuId}/promotions/archive/`
}
